import React, {useEffect} from 'react';
import s from '../../../PersonalOffice/MyOrders/MyOrdersForManager.module.css';
import searchIcon from '../../../assets/img/icons/akar-icons_search.svg';
import {Field, useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';
import {useDebounce} from 'use-debounce';
import {toast} from 'react-toastify';
type Props = {
	fieldName: string;
	callback?: (values?: any) => void;
};
const SearchInputFurfur: React.FC<Props> = ({fieldName, callback}) => {
	const {t} = useTranslation();
	const {values} = useFormikContext<any>();
	const [debounceSearch] = useDebounce(values[fieldName], 500);

	const handleClickFurfurButton = () => {
		if (values[fieldName].length >= 3)
			callback && callback({[fieldName]: debounceSearch, filter_active: true});
	};
	useEffect(() => {
		if (debounceSearch.length < 3 && debounceSearch.length > 1) {
			toast(t('Введіть будь ласка більше 3 символів'));
			callback && callback({filter_active: false});
		} else if (debounceSearch.length >= 3) {
			callback && callback({[fieldName]: debounceSearch});
		}
	}, [debounceSearch]);
	return (
		<div className={s.searchInput}>
			<Field
				name={fieldName}
				value={values[fieldName] ?? ''}
				type="text"
				placeholder={t('Пошук')}
			/>
			<button onClick={handleClickFurfurButton} type={'button'}>
				<img src={searchIcon} alt="searchIcon" />
			</button>
		</div>
	);
};

export default SearchInputFurfur;
